const sectionTypesPTO = Object.freeze({
    PROPERTY_INFO: 1,
    TAXES_ASSESMENTS: 2,
    RESTRICTIVE_COVENANTS: 3,
    RECORDED_PLAT: 4,
    LIENS: 5,
    EASEMENTS: 6,
    TITLE_INSURANCE_APPLICATION: 7,
    ADDITIONAL_INFO: 8,
    REVIEW_PTO: 9
});

const sectionTypesSTF = Object.freeze({
    PROPERTY_INFO: 14,
    TAXES_ASSESMENTS: 15,
    RESTRICTIVE_COVENANTS: 16,
    RECORDED_PLAT: 17,
    LIENS: 18,
    EASEMENTS: 19,
    DEED: 23,
    ADDITIONAL_INFO: 21,
    REVIEW_PTO: 22,
    TITLE_INSURANCE_APPLICATION: 20
});

const PTO_DATA_FIELDS_DUPLICATE = Object.freeze({
    dataToDuplicate: [
        {
            sectionToDuplicateFields: ["titleCompany", "transactionType", "useOfProperty", "street", "zipcode", "city", "state", "county", "interestOrEstate", "notes"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesPTO.PROPERTY_INFO
        },
        {
            sectionToDuplicateFields: ["parcelId"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesPTO.TAXES_ASSESMENTS
        },
        {
            sectionToDuplicateFields: ["restrictiveCovenants", "violation", "forfeiture", "feetFromFront", "feetFromRear","feetFromSide","feetFromSideStreet", "easementsOthers", "reportAttached"],
            sectionDetailToDuplicateFields: ["book", "pageNo"],
            sectionType: sectionTypesPTO.RESTRICTIVE_COVENANTS
        },
        {
            sectionToDuplicateFields: ["recordedPlat", "feetFromFront", "feetFromRear","feetFromSide","feetFromSideStreet", "violation", "accessToPublicRightOfWay", "easementsOthers"],
            sectionDetailToDuplicateFields: ["book", "pageNo"],
            sectionType: sectionTypesPTO.RECORDED_PLAT
        },
        {
            sectionToDuplicateFields: [],
            sectionDetailToDuplicateFields: ["type", "inFavorOf", "book", "pageNo", "countyRegistry", "lienType"],
            sectionType: sectionTypesPTO.EASEMENTS
        },
        {
            sectionToDuplicateFields: ["mobileHome", "includeMobileHomeCoverage", "constructionInProgress", "mechanicsLienAgent", "lienAgentName", "book", "page"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesPTO.ADDITIONAL_INFO
        }
    ]
});

const STF_DATA_FIELDS_DUPLICATE = Object.freeze({
    dataToDuplicate: [
        {
            sectionToDuplicateFields: ["titleCompany", "transactionType", "useOfProperty", "street", "zipcode", "city", "state", "county", "interestOrEstate", "notes"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.PROPERTY_INFO
        },
        {
            sectionToDuplicateFields: ["parcelId"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.TAXES_ASSESMENTS
        },
        {
            sectionToDuplicateFields: ["restrictiveCovenants", "violation", "forfeiture", "feetFromFront", "feetFromRear","feetFromSide","feetFromSideStreet", "easementsOthers", "reportAttached"],
            sectionDetailToDuplicateFields: ["book", "pageNo"],
            sectionType: sectionTypesSTF.RESTRICTIVE_COVENANTS
        },
        {
            sectionToDuplicateFields: ["recordedPlat", "feetFromFront", "feetFromRear","feetFromSide","feetFromSideStreet", "violation", "accessToPublicRightOfWay", "easementsOthers"],
            sectionDetailToDuplicateFields: ["book", "pageNo"],
            sectionType: sectionTypesSTF.RECORDED_PLAT
        },
        {
            sectionToDuplicateFields: [],
            sectionDetailToDuplicateFields: ["type", "inFavorOf", "book", "pageNo", "countyRegistry", "lienType"],
            sectionType: sectionTypesSTF.EASEMENTS
        },
        {
            sectionToDuplicateFields: ["mobileHome", "includeMobileHomeCoverage", "constructionInProgress", "mechanicsLienAgent", "lienAgentName", "book", "page"],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.ADDITIONAL_INFO
        },
        {
            sectionToDuplicateFields: [],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.DEED
        },
        {
            sectionToDuplicateFields: [],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.LIENS
        },
        {
            sectionToDuplicateFields: [],
            sectionDetailToDuplicateFields: [],
            sectionType: sectionTypesSTF.TITLE_INSURANCE_APPLICATION
        }
    ]
});

export default Object.freeze({
    PTO_DATA_FIELDS_DUPLICATE,
    STF_DATA_FIELDS_DUPLICATE
});